import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import FormCol from './FormCol'
import FormRow from './FormRow'

export default function Group({ children, className, title }) {
  return (
    <div className={clsx('form-group', className)}>
      {title && (
        <FormRow>
          <FormCol>
            <div className="form-group__headline">{title}</div>
          </FormCol>
        </FormRow>
      )}
      {children}
    </div>
  )
}

Group.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string
}
